module.exports = __webpack_public_path__ + "static/media/outsell-featured.122489ea.jpg";